import { Component, OnInit, ViewChild } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { lastValueFrom, Subject, EMPTY } from "rxjs";
import { debounceTime, distinctUntilChanged, switchMap } from "rxjs/operators";
import { LoaderService } from "../../core/services/loader.service";
import { getBase64 } from "../../core/services/shared.service";
import { InsideInformation } from "../../core/models/vendor/addVendor/insideInformation";
import { VendorGroup } from "../../core/models/vendor/addVendor/vendorGroup";
import { VendorInformation } from "../../core/models/vendor/addVendor/vendorInformation";
import { WebsiteInformation } from "../../core/models/vendor/addVendor/websiteInformation";
import { GetAllVendorsDto } from "../../core/models/vendor/vendorListing/getAllVendors";
import { TableModule } from "primeng/table";
import { CommonModule } from "@angular/common";
import { AddNewClientService } from "../../core/services/add-new-client.service";
import { SelectModule } from "primeng/select";
import { EnumContactType } from "../../shared/enums/enumContactType";
import { ClientPurpose } from "../../shared/enums/clientPurpose";
import { FileUploadDto } from "../../core/models/shared/fileUploadDto";
import { FileType } from "../../shared/enums/fileType";
import { v4 as uuidv4 } from "uuid";
import { JniToastrService } from "../../core/services/jni-toastr.service";
import { VendorService } from "../../core/services/vendor.service";
import { City } from "../../core/models/client/addclient/cityList";
import { AddressCountryRegion } from "../../core/models/client/addclient/countryRegionList";
import { AddressCounty } from "../../core/models/client/addclient/countyList";
import { AddressState } from "../../core/models/client/addclient/stateList";
import { ZipCodeDetails } from "../../core/models/shared/zipCodeDetails";
import { District } from "../../core/models/vendor/summary/districtList";
import { AddVendorDto } from "../../core/models/vendor/addVendor/addVendorDto";
import { AddVendorContactDto } from "../../core/models/vendor/addVendor/addVendorContactDto";
import { AddressComponent } from "../../shared/components/address/address.component";
import { AddVendorFormDto } from "../../core/models/vendor/addVendor/addVendorFormDto";
import { Popover } from "primeng/popover";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { CheckboxModule } from "primeng/checkbox";
import { ToggleSwitchModule } from "primeng/toggleswitch";
import {
  FileUpload,
  FileUploadEvent,
  FileUploadHandlerEvent,
  FileUploadModule,
} from "primeng/fileupload";
import { ButtonModule } from "primeng/button";
import { GenericResponseDto } from "../../core/models/generic-response.dto";
import { Currency } from "../../core/models/shared/currencyList";
import { CustomerGroup } from "../../core/models/client/addclient/customerGroupList";
import { TypeList } from "../../core/models/shared/typeList";
import { ClientAttachment } from "../../core/models/client/details/clientAttachment";

@UntilDestroy()
@Component({
  selector: "jni-vendors",
  templateUrl: "./vendors.component.html",
  styleUrls: ["./vendors.component.scss"],
  imports: [
    TableModule,
    CommonModule,
    FormsModule,
    SelectModule,
    ReactiveFormsModule,
    SelectModule,
    AddressComponent,
    Popover,
    CardModule,
    InputTextModule,
    CheckboxModule,
    ToggleSwitchModule,
    FileUploadModule,
    ButtonModule,
  ],
})
export class VendorsComponent implements OnInit {
  active = 1;
  vendorVerification: GetAllVendorsDto[] = [];

  countryRegionList: AddressCountryRegion[] = [];
  zipList: ZipCodeDetails[] = [];
  districtList: District[] = [];
  cityList: City[] = [];
  countyList: AddressCounty[] = [];
  stateList: AddressState[] = [];
  countryRegionSelectedId = "";
  showSmallLoader = false;
  showSmallLoaderForVendorInfo = false;
  addressValidationStatus = true;
  vendorForm: FormGroup;
  zipSelectionCode = "";
  getFilteredZipCode: string[] = [];
  getZipCode: string[] = [];
  stateSelectedId = "";
  isAddressValidationButton = true;
  typeList: TypeList[] = [];
  customerGroupList: CustomerGroup[] = [];
  vendorGroupList: VendorGroup[] = [];
  vendorprofileArray: string[] = [];
  vendorprofileCsv = "";
  customerAccount = "Fetching...";
  customerAccountNumberStatus = true;
  vendorObj!: AddVendorDto;
  isPrimaryOne = "1";
  isPrimaryZero = "0";
  w9FileUrl?: GenericResponseDto<string>;
  files?: { w9File: string };
  fileObject: FileUploadDto[] = [];
  fileAttachment: ClientAttachment[] = [];
  currencyList: Currency[] = [];
  w9FileName = "";
  w9FileValidationMessage = false;
  w9FileRemove = false;
  w9FileSize = false;
  w9fileSizeInKb = 1024;
  defaultW9fileName = "W9 attached";
  isDragOver = false;
  ethinicOrigin = ["English", "Afro-Caribbean", "Other"];

  @ViewChild("fu", { static: false })
  fu!: FileUpload;
  filterVendorObject: GetAllVendorsDto[] | undefined;
  vendorDefaultSelectionId = "Organization";
  typePersonStatus = false;
  legalNameStatus = true;
  generalvendorObject: GetAllVendorsDto | undefined;
  taxId = "";
  legalName = "";
  firstName = "";
  w9FileTypeStatus = false;

  showZip = true;
  showDistrict = true;
  showPostBox = true;
  showCity = true;
  showCounty = true;
  showState = true;
  showStreetNumber = true;
  showStreet = true;
  showbuildingComplement = true;
  showAddressBook = true;
  showAppartment = true;

  feedbackScore: string | null = "0";
  isCriteriaSelected = false;
  feedbackCriteria = "";
  notes: string | undefined = "";
  qualityNotes: string | undefined = "";
  respNotes: string | undefined = "";
  timeNotes: string | undefined = "";
  respScore: string | null = "0";
  qualityScore: string | null = "0";
  timeScore: string | null = "0";

  currentlySelectedCriteria = "";
  public searchVendor$ = new Subject<string>();
  public searchTaxId$ = new Subject<string>();
  vendorGroupId = "";
  defaultCurrency = "USD";
  websiteNameIsRequired = true;

  @ViewChild("taxIdPopover") taxIdPopover!: Popover;
  @ViewChild("firstNamePopover") firstNamePopover!: Popover;

  constructor(
    private _formBuilder: FormBuilder,
    private _toastr: JniToastrService,
    private route: Router,
    private _addNewClientService: AddNewClientService,
    private _vendorService: VendorService,
    private _loaderService: LoaderService
  ) {
    this.vendorForm = this._formBuilder.group({
      id: 0,
      basicInformation: this._formBuilder.group({
        vendorAccountNumberD365: [""],
        vendorOrganizationNameD365: [
          "",
          [
            Validators.required,
            Validators.minLength(2),
            Validators.maxLength(200),
          ],
        ],
        firstNameD365: [""],
        middleNameD365: [""],
        lastNameD365: [""],
        vendorKnownAsNameD365: [
          "",
          [Validators.minLength(2), Validators.maxLength(200)],
        ],
        vendorPartyTypeD365: [""],
        vendorGroupIdD365: ["", [Validators.required]],
        tax1099FederalTaxIdD365: [
          "",
          [
            Validators.required,
            Validators.minLength(9),
            Validators.maxLength(22),
          ],
        ],
        privateBCVendorNotes: [""],
        publicVendorNotes: [""],
        vendorProfile: [""],
        ethinicOrigin: [""],
        salesCurrencyCodeD365: [""],
      }),
      addressInformation: this._formBuilder.group({
        countryRegionIdD365: ["", [Validators.required]],
        zipCodeD365: [{ value: "", disabled: true }],
        districtNameD365: [""],
        cityD365: [{ value: "", disabled: true }],
        countyD365: [""],
        streetNumberD365: [""],
        stateD365: [{ value: "", disabled: true }],
        addressD365: [""],
        streetD365: [""],
        purposeD365: ClientPurpose.Business,
        isPrimaryD365: "Yes",
        addressBook: [""],
        buildingComplimentD365: [""],
        apartment_RUD365: [""],
        postBoxD365: [""],
        addressFormat: [""],
        validateAddress: [""],
        melissaAddressKeyD365: [""],
        addressLine1: [""],
        addressLine2: [""],
        addressLine3: [""],
      }),
      vendorInformation: this._formBuilder.group({
        vendorNameD365: [
          "",
          [Validators.pattern("^[a-zA-Z0-9 ]+|[\u10D0-\u10F0]+$")],
        ],
        vendorPhoneNumberD365: [""],
        vendorEmailAddressD365: [
          "",
          [
            Validators.pattern(
              `^[a-zA-Z0-9._%+-]+(?:'[a-zA-Z0-9._%+-]+)?@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$`
            ),
          ],
        ],
      }),
      insideInformation: this._formBuilder.group({
        insideNameD365: [
          "",
          [Validators.pattern("^[a-zA-Z0-9 ]+|[\u10D0-\u10F0]+$")],
        ],
        insidePhoneNumberD365: [""],
        insideEmailAddressD365: [
          "",
          [
            Validators.pattern(
              `^[a-zA-Z0-9._%+-]+(?:'[a-zA-Z0-9._%+-]+)?@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$`
            ),
          ],
        ],
      }),
      websiteInformation: this._formBuilder.group({
        websiteNameApplicable: [true],
        websiteNameD365: [""],
        websitePhoneNumberD365: [""],
        websiteEmailAddressD365: [
          "",
          [
            Validators.pattern(
              `^[a-zA-Z0-9._%+-]+(?:'[a-zA-Z0-9._%+-]+)?@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$`
            ),
          ],
        ],
      }),
      vendorFeedback: this._formBuilder.group({
        quality: [""],
        resp: [""],
        time: [""],
        qualityScore: [""],
        respScore: [""],
        timeScore: [""],
      }),
    });
  }

  formErrors: Record<string, string> = {
    vendorOrganizationNameD365: "",
    vendorGroupIdD365: "",
    tax1099FederalTaxIdD365: "",
    countryRegionIdD365: "",
    vendorNameD365: "",
    vendorPhoneNumberD365: "",
    vendorEmailAddressD365: "",
    insideNameD365: "",
    insidePhoneNumberD365: "",
    insideEmailAddressD365: "",
    websiteNameD365: "",
    websitePhoneNumberD365: "",
    websiteEmailAddressD365: "",
    vendorKnownAsNameD365: "",
  };

  validationMessages: Record<string, Record<string, string>> = {
    vendorOrganizationNameD365: {
      required: "Legal name is required.",
      pattern: "Legal name format is not correct.",
      minlength: "Legal name must be greater than 2 characters.",
      maxlength: "Legal name must be less than 200 characters.",
    },
    firstNameD365: {
      required: "First name is required.",
    },
    middleNameD365: {
      required: "Middle name is required.",
    },
    lastNameD365: {
      required: "Last name is required.",
    },
    tax1099FederalTaxIdD365: {
      required: "Tax id is required.",
      minlength: "Tax id must be greater than 8 characters.",
      maxlength: "Tax id must be less than 17 characters.",
    },
    vendorGroupIdD365: {
      required: "Group is required.",
    },
    countryRegionIdD365: {
      required: "Country is required.",
    },
    vendorNameD365: {
      pattern: "Name format is not correct.",
    },
    vendorPhoneNumberD365: {
      pattern: "Phone number must contain 11 digits",
    },
    vendorEmailAddressD365: {
      pattern: "Email format is not correct.",
    },
    insideNameD365: {
      pattern: "Name format is not correct.",
    },
    insidePhoneNumberD365: {
      pattern: "Phone number must contain 11 digits.",
    },
    insideEmailAddressD365: {
      required: "Email is required.",
      pattern: "Email format is not correct.",
    },
    websiteNameD365: {
      required: "Website url is required.",
      pattern: "Name format is not correct.",
    },
    websitePhoneNumberD365: {
      pattern: "Phone number must contain 11 digits",
    },
    websiteEmailAddressD365: {
      pattern: "Email format is not correct.",
    },
    vendorKnownAsNameD365: {
      minlength: "Known as must be greater than 2 characters.",
      maxlength: "known as must be less than 200 characters.",
    },
  };

  ngOnInit(): void {
    this.applicableClickEvent(true);
    this.getTypeListData();
    this.getVendorGroupListData();
    this.getCountryRegionListData();
    this.getVendorAccountNumber();
    this.legalNameSearch();
    this.searchTaxId();
    this.getCurrencyListData();
    this.vendorForm.valueChanges.subscribe(data => {
      //this.logValidationErrors(this.clientForm);
      this.addressValidation(data);
    });
    this.vendorForm
      .get(["basicInformation", "vendorAccountNumberD365"])
      ?.disable();
  }

  getVendorAccountNumber() {
    this._vendorService
      .getVendorAccount()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.customerAccount =
            res.data != undefined ? res.data?.accountNumber : "";
          if (
            this.customerAccount != "Fetching..." &&
            this.customerAccount != ""
          ) {
            this.customerAccountNumberStatus = false;
          }
          if (this.customerAccount == "") {
            this.customerAccount = "Fetching...";
          }
        },
      });
  }

  getCurrencyListData() {
    this._addNewClientService
      .getCurrencyList()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.currencyList = res.data;
        },
      });
  }

  filterAddressFormats(countryId: string) {
    const filteredRegions = this.countryRegionList.filter(
      x => x.countryRegionD365 == countryId
    );
    this.getAddressFormats(filteredRegions[0].addressFormatD365);
  }

  getAddressFormats(formatId: string) {
    this.showSmallLoader = true;
    this._addNewClientService
      .getAddressFormatsByFormatId(formatId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.filterAddressesUsingAddressFormats(res?.data?.descriptionD365);
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }
  filterAddressesUsingAddressFormats(description: string | null) {
    if (
      !description?.toLowerCase().includes("zip") &&
      !description?.toLowerCase().includes("postal_code") &&
      !description?.toLowerCase().includes("postcode") &&
      !description?.toLowerCase().includes("postal code")
    ) {
      this.showZip = false;
    } else {
      this.showZip = true;
    }
    if (!description?.toLowerCase().includes("district")) {
      this.showDistrict = false;
    } else {
      this.showDistrict = true;
    }
    if (!description?.toLowerCase().includes("city")) {
      this.showCity = false;
    } else {
      this.showCity = true;
    }
    if (!description?.toLowerCase().includes("county")) {
      this.showCounty = false;
    } else {
      this.showCounty = true;
    }
    if (
      !description?.toLowerCase().includes("state") &&
      !description?.toLowerCase().includes("province")
    ) {
      this.showState = false;
    } else {
      this.showState = true;
    }
    if (!description?.toLowerCase().includes("street")) {
      this.showStreet = false;
    } else {
      this.showStreet = true;
    }
    if (!description?.toLowerCase().includes("number")) {
      this.showStreetNumber = false;
    } else {
      this.showStreetNumber = true;
    }
    if (
      !description?.toLowerCase().includes("complement") &&
      !description?.toLowerCase().includes("building")
    ) {
      this.showbuildingComplement = false;
    } else {
      this.showbuildingComplement = true;
    }
    if (!description?.toLowerCase().includes("apartment")) {
      this.showAppartment = false;
    } else {
      this.showAppartment = true;
    }
    const poBox = description
      ?.toLowerCase()
      .split(",")
      .join(" ")
      .split("/")
      .join(" ")
      .split("_")
      .join(" ")
      .split(";")
      .join(" ")
      .split(" ")
      .some(x => x == "post" || x == "postbox");
    if (!poBox) {
      this.showPostBox = false;
    } else {
      this.showPostBox = true;
    }
  }
  private removeAddressFields() {
    if (!this.showZip) {
      this.vendorForm.patchValue({
        addressInformation: {
          zipCodeD365: "",
        },
      });
    }
    if (!this.showDistrict) {
      this.vendorForm.patchValue({
        addressInformation: {
          districtNameD365: "",
        },
      });
    }
    if (!this.showPostBox) {
      this.vendorForm.patchValue({
        addressInformation: {
          postBoxD365: "",
        },
      });
    }
    if (!this.showCity) {
      this.vendorForm.patchValue({
        addressInformation: {
          cityD365: "",
        },
      });
    }
    if (!this.showCounty) {
      this.vendorForm.patchValue({
        addressInformation: {
          countyD365: "",
        },
      });
    }
    if (!this.showState) {
      this.vendorForm.patchValue({
        addressInformation: {
          stateD365: "",
        },
      });
    }
    if (!this.showStreetNumber) {
      this.vendorForm.patchValue({
        addressInformation: {
          streetNumberD365: "",
        },
      });
    }
    if (!this.showStreet) {
      this.vendorForm.patchValue({
        addressInformation: {
          streetD365: "",
        },
      });
    }
    if (!this.showbuildingComplement) {
      this.vendorForm.patchValue({
        addressInformation: {
          buildingComplimentD365: "",
        },
      });
    }
    if (!this.showAppartment) {
      this.vendorForm.patchValue({
        addressInformation: {
          apartment_RUD365: "",
        },
      });
    }
  }

  addressValidation(data: AddVendorFormDto) {
    const addressObj = data.addressInformation;
    if (
      addressObj.countryRegionIdD365 != "" &&
      addressObj.countryRegionIdD365 != null &&
      addressObj.cityD365 != "" &&
      addressObj.cityD365 != null &&
      addressObj.stateD365 != "" &&
      addressObj.stateD365 != null
    ) {
      this.isAddressValidationButton = false;
      // this.vendorForm
      //   .get(['addressInformation', 'addressD365'])
      //   ?.setValidators(Validators.required);
    } else {
      // this.vendorForm
      //   .get(['addressInformation', 'addressD365'])
      //   ?.setValidators(Validators.required);
      this.isAddressValidationButton = true;
    }
  }

  logValidationErrors(group: FormGroup = this.vendorForm): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        this.formErrors[key] = "";
        if (
          abstractControl &&
          !abstractControl.valid &&
          (abstractControl.touched || abstractControl.dirty)
        ) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey && messages) {
              this.formErrors[key] += messages[errorKey] + " ";
            }
          }
        }
      }
    });
  }

  getCountryRegionListData() {
    this._addNewClientService
      .getCountryRegionList()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.countryRegionList = res?.data;
        },
      });
  }

  getVendorGroupListData() {
    this._vendorService
      .getVendorGroupList()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.vendorGroupList = res?.data;
          const allGroup = this.vendorGroupList.filter(
            x => x.vendorGroupIdD365.toLowerCase() == "all"
          );
          if (allGroup) {
            this.vendorGroupId = allGroup[0].vendorGroupIdD365;
          }
        },
      });
  }

  getTypeListData() {
    this._addNewClientService
      .getTypeList()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res?.data) {
            this.typeList = res.data.filter(
              x => !x.typeDescription?.toLowerCase()?.includes("person")
            );
          }
        },
      });
  }

  onCountryRegionSelection(countryid: string) {
    if (countryid) {
      this.vendorForm.get(["addressInformation", "zipCodeD365"])?.enable();
      this.vendorForm.get(["addressInformation", "districtNameD365"])?.enable();
      this.vendorForm.get(["addressInformation", "cityD365"])?.enable();
      this.vendorForm.get(["addressInformation", "countyD365"])?.enable();
      this.vendorForm.get(["addressInformation", "stateD365"])?.enable();
    } else {
      this.vendorForm.get(["addressInformation", "zipCodeD365"])?.disable();
      this.vendorForm
        .get(["addressInformation", "districtNameD365"])
        ?.disable();
      this.vendorForm.get(["addressInformation", "cityD365"])?.disable();
      this.vendorForm.get(["addressInformation", "countyD365"])?.disable();
      this.vendorForm.get(["addressInformation", "stateD365"])?.disable();
    }

    const countryregionid = countryid ?? "";
    if (countryregionid == "") {
      if (this.zipList != null) this.zipList.length = 0;
      if (this.districtList != null) this.districtList.length = 0;
      if (this.cityList != null) this.cityList.length = 0;
      if (this.countyList != null) this.countyList.length = 0;
      if (this.stateList != null) this.stateList.length = 0;
      this.addressValidationStatus = true;
      this.updateValueOnCountrySelection();
    } else {
      this.updateValueOnCountrySelection();
      this.filterAddressFormats(countryregionid);
      this.getCountyListData(countryregionid);
      this.getStateListData(countryregionid);
    }
  }

  updateValueOnCountrySelection() {
    this.vendorForm.patchValue({
      addressInformation: {
        zipCodeD365: "",
        districtNameD365: "",
        cityD365: "",
        countyD365: "",
        stateD365: "",
      },
    });
  }

  getCountyListData(id: string) {
    this.showSmallLoader = true;
    this._addNewClientService
      .getCountyList(id)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.countyList = res?.data;
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  getStateListData(id: string) {
    this.showSmallLoader = true;
    this._addNewClientService
      .getStateList(id)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.stateList = res?.data;
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  // async zipCodeSearchFilter(event: any) {
  //   this.selectedZipCode(event.value);
  // }

  // selectedZipCode(zipCode: any) {
  //   if (!zipCode) {
  //     return;
  //   }
  //   this._addNewClientService
  //     .getPostalCodeByZipCode(zipCode)
  //     .subscribe((res) => {
  //       this.showSmallLoader = true;
  //       if (!res.data) {
  //         this.showSmallLoader = false;
  //         return;
  //       }
  //       this._addNewClientService
  //         .getCityList(res.data.stateId, res.data.countryRegionId)
  //         .pipe(
  //           map((cityResponse) => {
  //             this.cityList = cityResponse.data;

  //             return cityResponse.data.filter(
  //               (city) =>
  //                 city.cityKeyD365?.includes(res?.data?.cityId) &&
  //                 city.countryRegionIdD365 == res?.data?.countryRegionId &&
  //                 city.countyIdD365 == res?.data?.countyId &&
  //                 city.stateIdD365 == res?.data?.stateId
  //             );
  //           })
  //         )
  //         .pipe(untilDestroyed(this))
  //         .subscribe({
  //           next: (response) => {
  //             this.vendorForm.patchValue({
  //               addressInformation: {
  //                 countyD365: response[0]?.countyIdD365,
  //                 cityD365: response[0]?.nameD365,
  //                 stateD365: response[0]?.stateIdD365,
  //                 streetD365: res?.data?.street
  //               }
  //             });
  //             this.showSmallLoader = false;
  //           },
  //           error: (response) => {
  //             this.showSmallLoader = false;
  //           }
  //         });
  //     });
  // }

  // searchZipCode: OperatorFunction<string, readonly string[]> = (
  //   text$: Observable<string>
  // ) =>
  //   text$.pipe(
  //     debounceTime(200),
  //     distinctUntilChanged(),
  //     switchMap(async (term: string) =>
  //       term.length < 4
  //         ? []
  //         : (this.getFilteredZipCode = await this.getZipListData(
  //             this.countryRegionSelectedId,
  //             term
  //           ))
  //     )
  //   );

  // async getZipListData(id: string, name: string) {
  //   this.getFilteredZipCode = [];
  //   this.showSmallLoader = true;
  //   const res = await lastValueFrom(
  //     this._addNewClientService.getZipList(id, name).pipe(untilDestroyed(this))
  //   );
  //   this.getZipCode = res.data;
  //   this.showSmallLoader = false;
  //   return this.getZipCode;
  // }

  // onStateSelectionChange(stateid: string) {
  //   this.vendorForm.patchValue({ addressInformation: { cityD365: '' } });
  //   this.getCityListData(stateid, this.countryRegionSelectedId);
  // }

  redirectToVendorListing() {
    const url = "/vendors";
    this.route.navigate([url]);
  }

  // getCityListData(stateid: string, countryid: string) {
  //   this.showSmallLoader = true;
  //   this._addNewClientService
  //     .getCityList(stateid, countryid)
  //     .pipe(untilDestroyed(this))
  //     .subscribe({
  //       next: (res) => {
  //         this.cityList = res?.data;
  //         this.showSmallLoader = false;
  //       },
  //       error: () => {
  //         this.showSmallLoader = false;
  //       }
  //     });
  // }

  validateAddress() {
    this.showSmallLoader = true;
    const address = "usa ca street 1";
    this._addNewClientService
      .checkAddressValidation(address)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.showSmallLoader = false;
          if (res.data == true) {
            // this.vendorForm
            //   .get(['addressInformation', 'addressD365'])
            //   ?.clearValidators();
            // this.vendorForm
            //   .get(['addressInformation', 'addressD365'])
            //   ?.updateValueAndValidity();
            this.addressValidationStatus = false;
          }
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  venderprofileCheckboxButton(event: MouseEvent) {
    const value = event.target as HTMLInputElement;
    if (value?.checked) {
      this.vendorprofileArray.push(value?.name);
    } else {
      const index = this.vendorprofileArray.indexOf(value?.name);
      if (index !== -1) {
        this.vendorprofileArray.splice(index, 1);
      }
    }
  }

  async getAttachmentUrlData(attachment: FileUploadDto[]) {
    const w9Obj = attachment.filter(x => x.fileName === this.defaultW9fileName);
    if (w9Obj.length > 0) {
      this.w9FileUrl = await lastValueFrom(
        this._addNewClientService.getRescaleAttachmentUrl(w9Obj)
      );
    }
    this.files = {
      w9File: this.w9FileUrl != undefined ? this.w9FileUrl.data : "",
    };
  }

  async getVendorW9Upload(event: FileUploadEvent) {
    //const target = file?.target as HTMLInputElement;
    if (event.files && event.files?.length > 0) {
      const fileObj = event.files[0];
      const filesize = Math.round(fileObj.size / this.w9fileSizeInKb);
      if (fileObj.type == "application/pdf") {
        this.w9FileTypeStatus = false;
        if (filesize <= this.w9fileSizeInKb) {
          this.w9FileName = fileObj.name;
          const fileextension =
            "." + fileObj?.name?.split(".")?.pop()?.toLowerCase();
          await getBase64(fileObj).then(data => {
            const base64 = data as string;
            this.createAttachmentFileObject(
              this.defaultW9fileName,
              FileType.url,
              base64
            );
            this.createFileUploadDto(
              base64,
              this.defaultW9fileName,
              fileextension,
              filesize,
              fileObj.type
            );
          });
          this.w9FileValidationMessage = false;
          this.w9FileRemove = true;
          this.w9FileSize = false;
        } else {
          this.w9FileSize = true;
        }
      } else {
        this.w9FileTypeStatus = true;
      }
    }
  }

  // Handler for the new PrimeNG fileupload with custom template
  handleW9Upload(event: FileUploadHandlerEvent): void {
    if (event.files && event.files.length > 0) {
      // Convert FileUploadHandlerEvent to FileUploadEvent format
      const mockEvent = {
        files: event.files,
      } as FileUploadEvent;

      this.getVendorW9Upload(mockEvent);

      // Clear the file selection after upload
      event.files.length = 0;

      // Clear the PrimeNG FileUpload component's internal state to prevent showing file details
      if (this.fu) {
        setTimeout(() => {
          this.fu.clear();
        }, 100);
      }
    }
  }

  // Helper method to format file size for display
  formatFileSize(bytes: number): string {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  }

  // Drag and drop event handlers
  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
  }

  onDragEnter(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = true;
  }

  onFileDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      const fileEvent = { files: Array.from(files) };
      this.handleW9Upload(fileEvent);
    }
  }

  createAttachmentFileObject(name: string, extension: string, data: string) {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = today.getMonth() + 1;
    const dd = today.getDate();
    const currentDate = mm + "-" + dd + "-" + yyyy;
    this.defaultW9fileName = name + " " + currentDate;
    this.fileAttachment.push({
      typeIdD365: extension,
      notesD365: data,
      restrictionD365: 1,
      descriptionD365: name + " " + currentDate,
      // createdDate: "",
      // createdBy: "",
      // lastModifiedDate: null,
      // lastModifiedBy: null,
      // isActive: false,
    });
  }

  createFileUploadDto(
    data: string,
    name: string,
    extension: string,
    size: number,
    filemimetype: string
  ) {
    const base64File = data.split(",")[1];
    this.fileObject.push({
      base64: base64File,
      fileName: name,
      fileExtension: extension,
      fileSize: size,
      fileMimeType: filemimetype,
    });
  }

  legalNameSearch() {
    this.searchVendor$
      .pipe(
        debounceTime(1000),
        distinctUntilChanged(),
        switchMap((searchitem: string) => {
          this.vendorVerification = [];
          this.showSmallLoaderForVendorInfo = true;
          this.legalName = searchitem;
          if (
            this.vendorForm.get(["basicInformation", "tax1099FederalTaxIdD365"])
              ?.value != null
          ) {
            this.taxId = this.vendorForm.get([
              "basicInformation",
              "tax1099FederalTaxIdD365",
            ])?.value;
          }
          if (this.legalName || this.taxId) {
            return this._vendorService.getVendorOnNameFilter(
              this.legalName,
              this.taxId
            );
          }
          return EMPTY;
        })
      )
      .subscribe({
        next: (res: GenericResponseDto<GetAllVendorsDto[]>) => {
          if (res.data != null) {
            this.vendorVerification = res.data;
          }
          this.showSmallLoaderForVendorInfo = false;
        },
        error: () => {
          this.showSmallLoaderForVendorInfo = false;
        },
      });
  }

  onLegalNameFilter(event: KeyboardEvent, target: HTMLElement) {
    if (this.taxIdPopover) {
      this.taxIdPopover.show(event, target);
    }
  }

  searchTaxId() {
    this.searchTaxId$
      .pipe(
        debounceTime(1000),
        distinctUntilChanged(),
        switchMap((searchitem: string) => {
          this.vendorVerification = [];
          this.showSmallLoaderForVendorInfo = true;
          this.taxId = searchitem;
          if (
            this.vendorForm.get([
              "basicInformation",
              "vendorOrganizationNameD365",
            ])?.value != null
          ) {
            this.legalName = this.vendorForm.get([
              "basicInformation",
              "vendorOrganizationNameD365",
            ])?.value;
          }
          if ((this.legalName || this.taxId) && this.taxId.length >= 9) {
            return this._vendorService.getVendorOnNameFilter(
              this.legalName,
              this.taxId
            );
          } else {
            this.showSmallLoaderForVendorInfo = false;
          }
          return EMPTY;
        })
      )
      .subscribe({
        next: (res: GenericResponseDto<GetAllVendorsDto[]>) => {
          if (res.data != null) {
            this.vendorVerification = res.data;
          }
          this.showSmallLoaderForVendorInfo = false;
        },
        error: () => {
          this.showSmallLoaderForVendorInfo = false;
        },
      });
  }

  onTaxIdFilter(event: KeyboardEvent, target: HTMLElement) {
    if (this.taxIdPopover) {
      this.taxIdPopover.show(event, target);
    }
  }

  onFirstNameFilter(event: KeyboardEvent) {
    const value = event.target as HTMLInputElement;
    this.vendorVerification = [];
    this.showSmallLoaderForVendorInfo = true;
    this.firstName = value?.value;
    if (
      this.vendorForm.get(["basicInformation", "tax1099FederalTaxIdD365"])
        ?.value != null
    ) {
      this.taxId = this.vendorForm.get([
        "basicInformation",
        "tax1099FederalTaxIdD365",
      ])?.value;
    }
    this._vendorService
      .getVendorOnNameFilter(this.firstName, this.taxId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (res: GenericResponseDto<GetAllVendorsDto[]>) => {
          if (res.data != null) {
            this.vendorVerification = res.data;
          }
          this.showSmallLoaderForVendorInfo = false;
          if (this.firstNamePopover) {
            this.firstNamePopover.show(event);
          }
        },
        error: () => {
          this.showSmallLoaderForVendorInfo = false;
          if (this.firstNamePopover) {
            this.firstNamePopover.show(event);
          }
        },
      });
  }

  getVendorDetails(accountNumber: string) {
    this.showSmallLoader = true;
    if (accountNumber != "") {
      this.filterVendorObject = this.vendorVerification.filter(
        x => x.vendorAccountNumber == accountNumber
      );
      if (this.filterVendorObject.length > 0) {
        this.generalvendorObject = this.filterVendorObject[0];
      }
      this.showSmallLoader = false;
    }
    this.showSmallLoader = false;
  }

  onVendorSelectionChange(type: string) {
    if (type === "Person") {
      this.typePersonStatus = true;
      this.legalNameStatus = false;
      this.removeLegalNameValidation();
      this.applyValidationOnFirstMiddleLastName();
      //this.emptyOrganizationTypeValue();
    } else if (type === "Organization") {
      this.typePersonStatus = false;
      this.legalNameStatus = true;
      this.removeValidationOnFirstMiddleLastName();
      this.applyLegalNameValidation();
      //this.emptyPersonTypeValue();
    }
  }

  removeValidationOnFirstMiddleLastName() {
    this.vendorForm
      .get(["basicInformation", "firstNameD365"])
      ?.clearValidators();
    this.vendorForm
      .get(["basicInformation", "firstNameD365"])
      ?.updateValueAndValidity();
    this.vendorForm
      .get(["basicInformation", "middleNameD365"])
      ?.clearValidators();
    this.vendorForm
      .get(["basicInformation", "middleNameD365"])
      ?.updateValueAndValidity();
    this.vendorForm
      .get(["basicInformation", "lastNameD365"])
      ?.clearValidators();
    this.vendorForm
      .get(["basicInformation", "lastNameD365"])
      ?.updateValueAndValidity();
  }

  applyValidationOnFirstMiddleLastName() {
    this.vendorForm
      .get(["basicInformation", "firstNameD365"])
      ?.setValidators(Validators.required);
    this.vendorForm
      .get(["basicInformation", "middleNameD365"])
      ?.setValidators(Validators.required);
    this.vendorForm
      .get(["basicInformation", "lastNameD365"])
      ?.setValidators(Validators.required);
  }

  onFirstNameValidation(event: KeyboardEvent) {
    const target = event.target as HTMLInputElement;
    const name = target.value;
    if (name.length > 0) {
      this.middleNameAndLastNameValidation();
    } else {
      this.applyMiddleNameAndLastNameValidation();
    }
  }

  middleNameAndLastNameValidation() {
    this.vendorForm
      .get(["basicInformation", "middleNameD365"])
      ?.clearValidators();
    this.vendorForm
      .get(["basicInformation", "middleNameD365"])
      ?.updateValueAndValidity();
    this.vendorForm
      .get(["basicInformation", "lastNameD365"])
      ?.clearValidators();
    this.vendorForm
      .get(["basicInformation", "lastNameD365"])
      ?.updateValueAndValidity();
  }

  applyMiddleNameAndLastNameValidation() {
    this.vendorForm
      .get(["basicInformation", "middleNameD365"])
      ?.setValidators(Validators.required);
    this.vendorForm
      .get(["basicInformation", "lastNameD365"])
      ?.setValidators(Validators.required);
  }

  onMiddleNameValidation(event: KeyboardEvent) {
    const target = event.target as HTMLInputElement;
    const name = target.value;
    if (name.length > 0) {
      this.firstNameAndLastNameValidation();
    } else {
      this.applyFirstNameAndLastNameValidation();
    }
  }

  firstNameAndLastNameValidation() {
    this.vendorForm
      .get(["basicInformation", "firstNameD365"])
      ?.clearValidators();
    this.vendorForm
      .get(["basicInformation", "firstNameD365"])
      ?.updateValueAndValidity();
    this.vendorForm
      .get(["basicInformation", "lastNameD365"])
      ?.clearValidators();
    this.vendorForm
      .get(["basicInformation", "lastNameD365"])
      ?.updateValueAndValidity();
  }

  applyFirstNameAndLastNameValidation() {
    this.vendorForm
      .get(["basicInformation", "firstNameD365"])
      ?.setValidators(Validators.required);
    this.vendorForm
      .get(["basicInformation", "lastNameD365"])
      ?.setValidators(Validators.required);
  }

  onLastNameValidation(event: KeyboardEvent) {
    const target = event.target as HTMLInputElement;
    const name = target.value;
    if (name.length > 0) {
      this.firstNameAndMiddleNameValidation();
    } else {
      this.applyfirstNameAndMiddleNameValidation();
    }
  }

  firstNameAndMiddleNameValidation() {
    this.vendorForm
      .get(["basicInformation", "middleNameD365"])
      ?.clearValidators();
    this.vendorForm
      .get(["basicInformation", "middleNameD365"])
      ?.updateValueAndValidity();
    this.vendorForm
      .get(["basicInformation", "firstNameD365"])
      ?.clearValidators();
    this.vendorForm
      .get(["basicInformation", "firstNameD365"])
      ?.updateValueAndValidity();
  }

  applyfirstNameAndMiddleNameValidation() {
    this.vendorForm
      .get(["basicInformation", "middleNameD365"])
      ?.setValidators(Validators.required);
    this.vendorForm
      .get(["basicInformation", "firstNameD365"])
      ?.setValidators(Validators.required);
  }

  removeLegalNameValidation() {
    this.vendorForm
      .get(["basicInformation", "vendorOrganizationNameD365"])
      ?.clearValidators();
    this.vendorForm
      .get(["basicInformation", "vendorOrganizationNameD365"])
      ?.updateValueAndValidity();
  }

  applyLegalNameValidation() {
    this.vendorForm
      .get(["basicInformation", "vendorOrganizationNameD365"])
      ?.setValidators(Validators.required);
  }

  emptyPersonTypeValue() {
    this.vendorForm.patchValue({
      basicInformation: {
        firstNameD365: "",
        middleNameD365: "",
        lastNameD365: "",
      },
    });
  }

  emptyOrganizationTypeValue() {
    this.vendorForm.patchValue({
      basicInformation: {
        vendorOrganizationNameD365: "",
      },
    });
  }

  addDataInVendortInfoArray(
    vendorContactArray: VendorInformation,
    locator: string,
    purpose: string,
    isPrimary: string,
    type: string
  ) {
    const obj = {
      firstNameD365: vendorContactArray.vendorNameD365.split(" ")[0] ?? "",
      lastNameD365: vendorContactArray.vendorNameD365.split(" ")[1] ?? "",
      locatorD365: locator,
      purposeD365: purpose,
      isPrimaryD365: isPrimary,
      typeD365: type,
      portalKeyD365: uuidv4(),
    } as AddVendorContactDto;
    return obj;
  }

  addDataInInsideInfoArray(
    insideContactArray: InsideInformation,
    locator: string,
    purpose: string,
    isPrimary: string,
    type: string,
    other: string
  ) {
    const obj = {
      firstNameD365: insideContactArray.insideNameD365.split(" ")[0],
      lastNameD365:
        insideContactArray.insideNameD365.split(" ")[1] == undefined
          ? ""
          : insideContactArray.insideNameD365.split(" ")[1],
      locatorD365: locator,
      purposeD365: purpose,
      isPrimaryD365: isPrimary,
      typeD365: type,
      otherSpecification: other,
      portalKeyD365: uuidv4(),
    } as AddVendorContactDto;
    return obj;
  }

  addDataInWebsiteInfoArray(
    websiteContactArray: WebsiteInformation,
    locator: string,
    purpose: string,
    isPrimary: string,
    type: string,
    other: string
  ) {
    const obj = {
      firstNameD365: websiteContactArray.websiteNameD365.split(" ")[0],
      lastNameD365:
        websiteContactArray.websiteNameD365.split(" ")[1] == undefined
          ? ""
          : websiteContactArray.websiteNameD365.split(" ")[1],
      locatorD365: locator,
      purposeD365: purpose,
      isPrimaryD365: isPrimary,
      typeD365: type,
      otherSpecification: other,
      portalKeyD365: uuidv4(),
      websiteNameApplicable: websiteContactArray.websiteNameApplicable ?? false,
    };
    return obj;
  }

  addUrlDataInWebsiteInfoArray(
    websiteContactArray: WebsiteInformation,
    locator: string,
    purpose: string,
    isPrimary: string,
    type: string,
    other: string
  ) {
    const obj = {
      firstNameD365: websiteContactArray.websiteNameD365,
      lastNameD365: "",
      locatorD365: websiteContactArray.websiteNameD365,
      purposeD365: purpose,
      isPrimaryD365: isPrimary,
      typeD365: type,
      otherSpecification: other,
      portalKeyD365: uuidv4(),
      websiteNameApplicable: websiteContactArray.websiteNameApplicable ?? false,
    } as AddVendorContactDto;
    return obj;
  }

  removeSpaceFromContactFields(addVendorDto: AddVendorFormDto) {
    if (addVendorDto.vendorInformation.vendorPhoneNumberD365 != "") {
      const phone: string =
        addVendorDto.vendorInformation.vendorPhoneNumberD365;
      if (phone.includes("+")) {
        addVendorDto.vendorInformation.vendorPhoneNumberD365 = phone.replace(
          /[- )(]/g,
          ""
        );
      } else {
        const withoutspacingnumber = phone.replace(/[- )(]/g, "");
        if (withoutspacingnumber.length >= 12) {
          const withoutspace =
            withoutspacingnumber.substring(0, 10) +
            " " +
            withoutspacingnumber.substring(10, withoutspacingnumber.length);
          addVendorDto.vendorInformation.vendorPhoneNumberD365 = withoutspace;
        } else {
          addVendorDto.vendorInformation.vendorPhoneNumberD365 =
            withoutspacingnumber;
        }
      }
    }
    if (addVendorDto.insideInformation.insidePhoneNumberD365 != "") {
      const phone: string =
        addVendorDto.insideInformation.insidePhoneNumberD365;
      if (phone.includes("+")) {
        addVendorDto.insideInformation.insidePhoneNumberD365 = phone.replace(
          /[- )(]/g,
          ""
        );
      } else {
        const withoutspacingnumber = phone.replace(/[- )(]/g, "");
        if (withoutspacingnumber.length >= 12) {
          const withoutspace =
            withoutspacingnumber.substring(0, 10) +
            " " +
            withoutspacingnumber.substring(10, withoutspacingnumber.length);
          addVendorDto.insideInformation.insidePhoneNumberD365 = withoutspace;
        } else {
          addVendorDto.insideInformation.insidePhoneNumberD365 =
            withoutspacingnumber;
        }
      }
    }
    if (addVendorDto.websiteInformation.websitePhoneNumberD365 != "") {
      const phone: string =
        addVendorDto.websiteInformation.websitePhoneNumberD365;
      if (phone.includes("+")) {
        addVendorDto.websiteInformation.websitePhoneNumberD365 = phone.replace(
          /[- )(]/g,
          ""
        );
      } else {
        const withoutspacingnumber = phone.replace(/[- )(]/g, "");
        if (withoutspacingnumber.length >= 12) {
          const withoutspace =
            withoutspacingnumber.substring(0, 10) +
            " " +
            withoutspacingnumber.substring(10, withoutspacingnumber.length);
          addVendorDto.websiteInformation.websitePhoneNumberD365 = withoutspace;
        } else {
          addVendorDto.websiteInformation.websitePhoneNumberD365 =
            withoutspacingnumber;
        }
      }
    }
  }
  getRating(score: string | null) {
    return parseInt(score ?? "0");
  }

  getCurrentRating() {
    if (this.currentlySelectedCriteria == "quality") {
      return parseInt(this.qualityScore ?? "0");
    } else if (this.currentlySelectedCriteria == "resp") {
      return parseInt(this.respScore ?? "0");
    } else if (this.currentlySelectedCriteria == "time") {
      return parseInt(this.timeScore ?? "0");
    }
    return parseInt("0");
  }

  criteriaChanged(name: string) {
    this.isCriteriaSelected = true;
    this.currentlySelectedCriteria = name;
    if (name == "quality") {
      this.feedbackScore = this.qualityScore;
    } else if (name == "time") {
      this.feedbackScore = this.timeScore;
    } else if (name == "resp") {
      this.feedbackScore = this.respScore;
    }
  }

  // feedbackLeave(event: any) {
  //   if (this.currentlySelectedCriteria == 'quality') {
  //     this.qualityScore = event;
  //   } else if (this.currentlySelectedCriteria == 'time') {
  //     this.timeScore = event;
  //   } else if (this.currentlySelectedCriteria == 'resp') {
  //     this.respScore = event;
  //   }
  // }

  submitButtonlogValidationErrors(group: FormGroup = this.vendorForm): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.submitButtonlogValidationErrors(abstractControl);
      } else {
        this.formErrors[key] = "";
        if (abstractControl && !abstractControl.valid) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey && messages) {
              this.formErrors[key] += messages[errorKey] + " ";
            }
          }
        }
      }
    });
  }

  async CreateNewVendor() {
    this.submitButtonlogValidationErrors();
    if (!this.vendorForm.valid) {
      this._loaderService.setLoaderState(false);
      return;
    }

    this._loaderService.setLoaderState(true);
    this.removeAddressFields();
    const addVendorDto = this.vendorForm.getRawValue();
    this.vendorprofileCsv = "";
    if (this.vendorprofileArray.length > 0) {
      this.vendorprofileCsv = this.vendorprofileArray.toString();
    }

    if (addVendorDto.basicInformation.vendorProfile == "") {
      addVendorDto.basicInformation.vendorProfile = this.vendorprofileCsv;
    }

    if (addVendorDto.basicInformation.vendorPartyTypeD365 != "") {
      if (addVendorDto.basicInformation.vendorPartyTypeD365 === "Person") {
        addVendorDto.basicInformation.vendorPartyTypeD365 = "0";
        addVendorDto.basicInformation.vendorOrganizationNameD365 = "";
      } else {
        addVendorDto.basicInformation.vendorPartyTypeD365 = "1";
        addVendorDto.basicInformation.firstNameD365 = "";
        addVendorDto.basicInformation.middleNameD365 = "";
        addVendorDto.basicInformation.lastNameD365 = "";
      }
    }
    if (this.fileAttachment.length > 0) {
      this.fileAttachment = this.fileAttachment.slice(-2);
      await this.getAttachmentUrlData(this.fileObject);
      this.fileAttachment.map(obj => {
        if (obj.descriptionD365 == this.defaultW9fileName) {
          obj.notesD365 = this.files?.w9File;
        }
      });
    }

    if (this.fileAttachment.length > 0) {
      addVendorDto.basicInformation.w9Url = this.fileAttachment[0].notesD365;
    }

    this.removeSpaceFromContactFields(addVendorDto);

    const vendorContactArray: AddVendorContactDto[] = [];
    if (
      addVendorDto.vendorInformation.vendorNameD365 != "" ||
      addVendorDto.vendorInformation.vendorPhoneNumberD365 != "" ||
      addVendorDto.vendorInformation.vendorEmailAddressD365 != ""
    ) {
      vendorContactArray.push(
        this.addDataInVendortInfoArray(
          addVendorDto.vendorInformation,
          addVendorDto.vendorInformation.vendorPhoneNumberD365,
          ClientPurpose.Business,
          this.isPrimaryOne,
          EnumContactType.Phone
        ),
        this.addDataInVendortInfoArray(
          addVendorDto.vendorInformation,
          addVendorDto.vendorInformation.vendorEmailAddressD365,
          ClientPurpose.Business,
          this.isPrimaryOne,
          EnumContactType.Email
        )
      );
    }
    if (
      addVendorDto.insideInformation.insideNameD365 != "" ||
      addVendorDto.insideInformation.insidePhoneNumberD365 != "" ||
      addVendorDto.insideInformation.insideEmailAddressD365 != ""
    ) {
      vendorContactArray.push(
        this.addDataInInsideInfoArray(
          addVendorDto.insideInformation,
          addVendorDto.insideInformation.insidePhoneNumberD365,
          ClientPurpose.Other,
          this.isPrimaryZero,
          EnumContactType.Phone,
          "Inside"
        ),
        this.addDataInInsideInfoArray(
          addVendorDto.insideInformation,
          addVendorDto.insideInformation.insideEmailAddressD365,
          ClientPurpose.Other,
          this.isPrimaryZero,
          EnumContactType.Email,
          "Inside"
        )
      );
    }
    if (
      addVendorDto.websiteInformation.websiteNameD365 != "" //||
      // addVendorDto.websiteInformation.websitePhoneNumberD365 != '' ||
      // addVendorDto.websiteInformation.websiteEmailAddressD365 != ''
    ) {
      vendorContactArray.push(
        this.addUrlDataInWebsiteInfoArray(
          addVendorDto.websiteInformation,
          addVendorDto.websiteInformation,
          ClientPurpose.Other,
          this.isPrimaryZero,
          EnumContactType.Url,
          "Website"
        )
      );
    }

    const vendorAddressArray = [];
    vendorAddressArray.push(addVendorDto.addressInformation);

    this.vendorObj = {
      id: 0,
      vendor: addVendorDto.basicInformation,
      vendorAddress: vendorAddressArray,
      vendorContacts: vendorContactArray,
      vendorFeedback: [
        {
          accountNumber: this.customerAccount,
          partyNumber: "",
          criteria: "quality",
          score: Number(this.qualityScore ?? "0"),
          notes: this.qualityNotes ?? "",
          id: 0,
          isVisible: null,
          createdDate: "",
          createdBy: "",
          lastModifiedDate: null,
          lastModifiedBy: null,
          isActive: false,
          totalRating: null,
        },
        {
          accountNumber: this.customerAccount,
          partyNumber: "",
          criteria: "resp",
          score: Number(this.respScore ?? "0"),
          notes: this.respNotes ?? "",
          id: 0,
          isVisible: null,
          createdDate: "",
          createdBy: "",
          lastModifiedDate: null,
          lastModifiedBy: null,
          isActive: false,
          totalRating: null,
        },
        {
          accountNumber: this.customerAccount,
          partyNumber: "",
          criteria: "time",
          score: Number(this.timeScore ?? "0"),
          notes: this.timeNotes ?? "",
          id: 0,
          isVisible: null,
          createdDate: "",
          createdBy: "",
          lastModifiedDate: null,
          lastModifiedBy: null,
          isActive: false,
          totalRating: null,
        },
      ],
      vendorAttachments: this.fileAttachment,
    };

    this._vendorService
      .addVendorData(this.vendorObj)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data != null) {
            this._toastr.success("Success", "Vendor added successfully");
            const url = `/vendors/vendor-summary/${this.customerAccount}`;
            this.route.navigate([url]);
          } else {
            this._toastr.error("Error", res.message || "Error adding vendor");
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", res || "Error adding vendor");
        },
      });
  }

  applicableClickEvent(obj: Event | boolean) {
    if (
      (obj instanceof Event && (obj.target as HTMLInputElement).checked) ||
      obj === true
    ) {
      this.websiteNameIsRequired = true;
      this.vendorForm
        .get(["websiteInformation", "websiteNameD365"])
        ?.setValidators(Validators.required);
      this.vendorForm
        .get(["websiteInformation", "websiteNameD365"])
        ?.updateValueAndValidity();
    } else {
      this.websiteNameIsRequired = false;
      this.vendorForm
        .get(["websiteInformation", "websiteNameD365"])
        ?.removeValidators(Validators.required);
      this.formErrors["websiteNameD365"] = "";
      this.vendorForm
        .get(["websiteInformation", "websiteNameD365"])
        ?.updateValueAndValidity();
    }
  }
}
